import * as tslib_1 from "tslib";
import { OnDestroy } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { GlobalAppService } from '@app/Modules/Shared/Services/global-app.service';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '@app/Modules/Shared/Services/app.service';
import { HttpService } from '@app/Modules/Shared/Services/http.service';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
var D2DFileDownloadComponent = /** @class */ (function () {
    function D2DFileDownloadComponent(httpServ, _globalAppService, translateServ, appServ, messageService, activatedRoute, router) {
        this.httpServ = httpServ;
        this._globalAppService = _globalAppService;
        this.translateServ = translateServ;
        this.appServ = appServ;
        this.messageService = messageService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.subscription = new Subscription();
        this.showNotification = false;
    }
    D2DFileDownloadComponent.prototype.agInit = function (params) {
        this.params = params;
        this.paramsValue = params.value;
    };
    D2DFileDownloadComponent.prototype.autoDownloadFile = function (reportId) {
        if (this.params && this.params.data && this.params.data.fileName) {
            this.makeAPICall(this.params.data.fileName);
        }
    };
    D2DFileDownloadComponent.prototype.notify = function (e) {
        var _this = this;
        this.showNotification = true;
        setTimeout(function () {
            _this.showNotification = false;
        }, 2000);
    };
    D2DFileDownloadComponent.prototype.setLanguageListener = function () {
        var _this = this;
        this.translateServ.get(['LCIDString'])
            .subscribe(function (value) {
            if (value) {
                _this.LCIDString = value.LCIDString;
            }
        });
    };
    D2DFileDownloadComponent.prototype.refresh = function (params) {
        return false;
    };
    D2DFileDownloadComponent.prototype.onLinkClick = function (event) {
        this.makeAPICall(event);
    };
    D2DFileDownloadComponent.prototype.makeAPICall = function (event) {
        var _this = this;
        if (this.params.data && this.params.data.fileName) {
            this.appServ.setLoadingStatus(true);
            var fileversion = 1;
            var request = {
                "d2DFileName": this.params.data.fileName,
                "fileversion": fileversion //passing fileversion as 1 as new file to be downloaded code is 1 and for old its 0
            };
            this.subscription.add(this.httpServ.d2DfileDownload(request).subscribe(function (res) {
                if (res && res.fileUrl) {
                    window.open(res.fileUrl, '_blank');
                }
                else {
                    _this.appServ.setLoadingStatus(false);
                    _this.messageService.add({ key: 'downloadError', detail: '0000.errorMessage', summary: 'errorLabel', severity: 'error' });
                }
            }, function (e) {
                _this.appServ.setLoadingStatus(false);
                _this.messageService.add({ key: 'downloadError', detail: '0000.errorMessage', summary: 'errorLabel', severity: 'error' });
            }, function () {
                _this.appServ.setLoadingStatus(false);
                if (_this.subscription) {
                    _this.subscription.unsubscribe();
                }
            }));
        }
    };
    D2DFileDownloadComponent.prototype.ngOnDestroy = function () {
        // Required for unsubscribing and destroying the component  
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    };
    D2DFileDownloadComponent = tslib_1.__decorate([
        AutoUnsubscribe(),
        tslib_1.__metadata("design:paramtypes", [HttpService,
            GlobalAppService,
            TranslateService,
            AppService,
            MessageService,
            ActivatedRoute,
            Router])
    ], D2DFileDownloadComponent);
    return D2DFileDownloadComponent;
}());
export { D2DFileDownloadComponent };
